import {createRouter, createWebHistory} from "vue-router"

import ModalListCountry from '../components/modals/ModalListCountry'

const routers =  createRouter({
    routes: [
        {
            path: '/:pathMatch(.*)*',
            name: 'ModalListCountry',
            component: ModalListCountry,
        },
    ],
    history: createWebHistory(),
})

export default routers;